var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"line-chart-container"},[_c('div',{ref:"chart",staticClass:"line-chart"})])
}
var staticRenderFns = []

export { render, staticRenderFns }